export class DaGiaSurvey{
    id : number;
    isMedicalIntervention : boolean;
    medicalInterventionDescription : string;
    isEducationalSupport : boolean;
    educationalSupportDescription
    isSocialAssistance : boolean;
    socialAssistanceDescription
    isSpecialVehicles : boolean;
    specialVehiclesDescription
    isOtherSupport : boolean;
    otherSupportDescription
    studentSurveyStatus : number; 
  } 